import { Text as Tx, } from "@bracket/ui";
import type { FunctionComponent } from "react";
import styled from "styled-components";
import packageJson from "../../../package.json";



/**
 * A badge component that displays the current application version from package.json
 * 
 * @returns JSX element displaying the version number in small typography
 */
export const VersionBadge: FunctionComponent = () => {
	return (
		<VersionBadgeWrapper>
			<Tx sm light>
				v{packageJson.version}
			</Tx>
		</VersionBadgeWrapper>
	);
};


const VersionBadgeWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--text-paragraph);
	> div {
		font-size: 0.75rem;
	}
`;
